import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table } from 'semantic-ui-react';

//Import Components
import ScheduleViewGranteeCalendarListItem from './ScheduleViewGranteeCalendarListItem';

class ScheduleViewGranteeDatesTable extends Component {
  render() {
    const { dates } = this.props;
    return (
      <Table celled>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>October</Table.HeaderCell>
            <Table.HeaderCell>November</Table.HeaderCell>
            <Table.HeaderCell>December</Table.HeaderCell>
            <Table.HeaderCell>January</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          <Table.Row>
            <Table.Cell>
              <ScheduleViewGranteeCalendarListItem dates={dates} month="10" />
            </Table.Cell>
            <Table.Cell>
              <ScheduleViewGranteeCalendarListItem dates={dates} month="11" />
            </Table.Cell>
            <Table.Cell>
              <ScheduleViewGranteeCalendarListItem dates={dates} month="12" />
            </Table.Cell>
            <Table.Cell>
              <ScheduleViewGranteeCalendarListItem dates={dates} month="01" />
            </Table.Cell>
          </Table.Row>
        </Table.Body>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>February</Table.HeaderCell>
            <Table.HeaderCell>March</Table.HeaderCell>
            <Table.HeaderCell>April</Table.HeaderCell>
            <Table.HeaderCell>May</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          <Table.Row>
            <Table.Cell>
              <ScheduleViewGranteeCalendarListItem dates={dates} month="02" />
            </Table.Cell>
            <Table.Cell>
              <ScheduleViewGranteeCalendarListItem dates={dates} month="03" />
            </Table.Cell>
            <Table.Cell>
              <ScheduleViewGranteeCalendarListItem dates={dates} month="04" />
            </Table.Cell>
            <Table.Cell>
              <ScheduleViewGranteeCalendarListItem dates={dates} month="05" />
            </Table.Cell>
          </Table.Row>
        </Table.Body>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>June</Table.HeaderCell>
            <Table.HeaderCell>July</Table.HeaderCell>
            <Table.HeaderCell>August</Table.HeaderCell>
            <Table.HeaderCell>September</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          <Table.Row>
            <Table.Cell>
              <ScheduleViewGranteeCalendarListItem dates={dates} month="06" />
            </Table.Cell>
            <Table.Cell>
              <ScheduleViewGranteeCalendarListItem dates={dates} month="07" />
            </Table.Cell>
            <Table.Cell>
              <ScheduleViewGranteeCalendarListItem dates={dates} month="08" />
            </Table.Cell>
            <Table.Cell>
              <ScheduleViewGranteeCalendarListItem dates={dates} month="09" />
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    );
  }
}

const mapStateToProps = state => {
  return {};
};

export default connect(mapStateToProps, {})(ScheduleViewGranteeDatesTable);
